import * as Sentry from '@sentry/vue';
import { type App } from 'vue';

export const initSentry = (app: App<Element>, { allowUrls }: { allowUrls: RegExp[] }): void => {
  const env = import.meta.env.VUE_APP_ENVIRONMENT;
  if (import.meta.env.VUE_APP_SENTRY_DSN && env === 'prod') {
    Sentry.init({
      app,
      dsn: import.meta.env.VUE_APP_SENTRY_DSN,
      environment: env,
      release: import.meta.env.VUE_APP_SENTRY_RELEASE_VERSION,
      allowUrls,
      initialScope: {
        tags: {
          platform: `${import.meta.env.VUE_APP_PLATFORM}`,
        },
      },
    });
  }
};
